import { useCallback } from 'react';
import { handleButtonAction } from '@/lib/instrumentation/button-instrumentation';

interface UseInstrumentedActionOptions {
  eventName: string;
  component?: string;
  successMessage?: string;
  errorMessage?: string;
}

interface InternalOptions {
  eventName: string;
  component: string;
  successMessage?: string;
  errorMessage?: string;
}

export function useInstrumentedAction<T extends (...args: unknown[]) => unknown>(
  handler: T,
  options: UseInstrumentedActionOptions
): T {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    ((...args: Parameters<T>) => {
      const actionOptions: InternalOptions = {
        eventName: options.eventName,
        component: options.component ?? 'unknown'
      };

      if (options.successMessage !== undefined) {
        actionOptions.successMessage = options.successMessage;
      }

      if (options.errorMessage !== undefined) {
        actionOptions.errorMessage = options.errorMessage;
      }

      return handleButtonAction(
        () => handler(...args),
        actionOptions
      );
    }) as T,
    [handler, options]
  );
}

